import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const TechnicalCapabilitiesSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./TechnicalCapabilitiesSubForm"))
);
